import { TKV2_ORDER_DEPRECIATION_SETTINGS_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrderDepreciationSettingsAPIError,
  GetTkv2OrderDepreciationSettingsAPIVariables,
  fetchGetTkv2OrderDepreciationSettingsAPI,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_DEPRECIATION_SETTINGS_API.GET;

export const useGetTkv2OrderDepreciationSettingsAPI = (
  variables: GetTkv2OrderDepreciationSettingsAPIVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrderDepreciationSettingsAPIError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<
  z.infer<typeof API_SCHEMA.RESPONSE>,
  GetTkv2OrderDepreciationSettingsAPIError
> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrderDepreciationSettingsAPIError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/depreciationSettings',
      operationId: 'getTkv2OrderDepreciationSettingsAPI',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetTkv2OrderDepreciationSettingsAPI({
        ...fetcherOptions,
        ...variables,
      });

      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
